import { useState } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { CalendarDays } from "lucide-react";

export function FrenchDatePicker({ value, onChange, testid, placeholder = "Choisir une date", minToday = false }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value + "T00:00:00") : undefined;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="h-12 w-full rounded-lg border border-slate-200 bg-white px-3 flex items-center gap-2 text-left text-slate-700 active:scale-[0.99] transition-transform">
          <CalendarDays className="w-4 h-4 text-slate-400 shrink-0" />
          {selected ? <span className="font-semibold">{format(selected, "dd/MM/yyyy", { locale: fr })}</span> : <span className="text-slate-400">{placeholder}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} selected={selected} disabled={minToday ? { before: today } : undefined}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
